import React from 'react';
import { Box } from '@mui/material';
import { tokens, type } from '../theme';
import { COMPETITION_LABELS, U15_PLUS } from '../config/seasons';

// League and Flex run side by side from U15 up, and which one a fixture belongs
// to changes who you play and which table it counts towards — so it is worth a
// real label rather than an absence.
//
// Only U15+ gets a chip. Below that every fixture is League, so a chip on every
// row would carry no information.
//
// This replaces a bold span prefixed with ' \u00b7 '. On an unplayed fixture the
// preceding time segment renders empty, so that separator had nothing in front
// of it and the row read "\u00b7 Flex".
const COLOURS = {
  league: tokens.navy,
  flex: tokens.flex,
  pro_player_pathway: tokens.navyHover,
};

const CompetitionChip = ({ competitionType, ageGroup, onDark = false }) => {
  if (!competitionType || !ageGroup) return null;
  if (!U15_PLUS.includes(ageGroup)) return null;

  const label = COMPETITION_LABELS[competitionType];
  if (!label) return null;
  const colour = COLOURS[competitionType] || tokens.inkMuted;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: 0.75,
        py: '1px',
        borderRadius: '3px',
        fontSize: type.label,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        lineHeight: 1.5,
        // On the navy card a tinted fill would disappear, so invert there.
        color: onDark ? '#FFFFFF' : colour,
        backgroundColor: onDark ? 'rgba(255,255,255,0.18)' : `${colour}14`,
        border: onDark ? '1px solid rgba(255,255,255,0.28)' : `1px solid ${colour}33`,
      }}
    >
      {label}
    </Box>
  );
};

export default CompetitionChip;
